module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh-left",
    attrs: {
      "id": "fore"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("A playwright should let his work speak for itself, but in the ninth year of running a theatre company, and my nineteenth of writing plays in the West Indies, I began as a commemorative essay the lengthy prologue that follows. This essay should not be considered either as an apologia or a manifesto, something to pummel the reader’s sympathy for the flaws in the plays. It merely tries to re-create the experience of a playwright with the company to which his plays became committed.")]), _vm._v(" "), _c('p', {
    staticClass: "txs"
  }, [_vm._v("I cannot list all who have helped over the years but I must acknowledge my gratitude to the Rockefeller Foundation for a three-year grant; to Dr. John Harrison, Dr. Gerald Freund, Mr. John Gillespie, Mr. Henri Salvatori, Mr. George White, Mr. Dale Wasserman, Mr. Derek Knight, and Mr. Errol Barrow; and to my wife, Margaret, for sharing in all the irritating practicalities of play production.")]), _vm._v(" "), _c('p', {
    staticClass: "ausig"
  }, [_vm._v("D. W.")]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Trinidad")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("September 1970")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-715470c7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/foreword.vue
// module id = 72
// module chunks = 0